import Circle from "@/components/Circle";
import { theme } from "@/core/theme";
import { WEBINAR_CONNECTIONS_QUERY } from "@/graphql/knowledgeCenter/webinars";
import PlayIcon from "@/images/PlayIcon";

import ListTemplate from "./ListTemplate";
import WebinarCard from "./WebinarCard";

export default function Webinars() {
  return (
    <ListTemplate
      defaultSort="-start_time"
      query={WEBINAR_CONNECTIONS_QUERY}
      connectionName="webinarConnections"
      objectsPlural="webinars"
      Card={WebinarCard}
      cardProps={{
        // Shop theme breakpoints: stacked below 1400px, row layout at 1400+ (matches pre-refactor card).
        stacked: [true, true, false]
      }}
      pageDescription="Sign up to upcoming or re-watch our full archive of webinar sessions. "
      pageTitle="Webinars"
      icon={
        <Circle bg="transparent" size={80} border="2px solid black">
          <PlayIcon fill={theme.colors.dark} size={40} />
        </Circle>
      }
    />
  );
}
